<template>
  <v-container>
    <v-row
      class="fill-height"
      align="center"
      justify="center"
    >
      <v-col sm="12" md="6" class="text-top">
        <h1 class="display-1 font-weight-thin mb-4">{{ $t("slide3.title") }}</h1>
        <h4 class="subheading">{{ $t("slide3.subtitle1") }}</h4>
        <h4 class="subheading">{{ $t("slide3.subtitle2") }}</h4>
        <!-- <v-btn class="ma-2 nobtn" outlined color="white"><v-icon>mdi-google-chrome</v-icon> Chrome Extension Coming Soon</v-btn> -->
        <!-- <v-btn class="ma-2" outlined color="white"><v-icon>mdi-one-up</v-icon> {{ $t("common.proBtnWhy") }}</v-btn> -->
        <v-btn class="ma-2" outlined color="white" @click="goToStore"><v-icon>mdi-google-chrome</v-icon> {{ $t("common.chromeBtn") }}</v-btn>
      </v-col>
      <v-col sm="12" md="6">
        <v-img width="360" src="https://firebasestorage.googleapis.com/v0/b/vuesaga-b8d1b.appspot.com/o/icons%2Fsaga-logo.png?alt=media&token=d39b7215-7c83-4a92-8c31-10c700ec372c" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Slide3',
  methods: {
    goToStore() {
      window.open('https://chrome.google.com/webstore/detail/fepolifledkafebcdlcdfgpmahdjgdgn', '_blank')
    }
  }
}
</script>

<style scoped>
.nobtn {
  cursor: default;
}
</style>
